import React, { useContext, useEffect, useState } from "react";
import { FiltersContext, AuthContext } from "@CONTEXTS";
import { DataTable } from "@MASTER";
import useLogics from "./logics";
import { DeliveryContext } from "@CONTEXTS";
import { Button, Modal, Space, message } from "antd";
import { BiPackage } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import PackageResultModal from "./package-result-modal";
import DeleteResultModal from "./delete-result-modal";
import { printBarcode } from "@DELIVERIES";
import { b64toBlob, TermalPrint } from "@HELPERS";
import PrintModal from "../../operation/table/print-modal";

const Table = () => {
  const { pagination, setPageAndLimit } = useContext(FiltersContext);
  const [loading, setLoading] = useState(true);
  const logics = useLogics({
    onLoading: (val) => setLoading(val),
    onPrint: (val) => handlePrint(val),
  });
  const { data, loading: apiLoading, mutate } = useContext(DeliveryContext);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [packageResultModal, setPackageResultModal] = useState(false);
  const [deleteResultModal, setDeleteResultModal] = useState(false);
  const [printModal, setPrintModal] = useState(false);
  const { info } = useContext(AuthContext);

  useEffect(() => {
    if (!apiLoading) {
      setLoading(false);
    }
  }, [apiLoading, data]);
  const handlePrint = async (arr) => {
    setLoading(true);
    const response = await printBarcode(arr);
    setLoading(false);
    if (response?.pdf) {
      const b64 = b64toBlob(response.pdf, "application/pdf");
      const blobUrl = URL.createObjectURL(b64);
      setPrintModal(blobUrl);
    }
    if (response?.zplArray) {
      TermalPrint(response?.zplArray);
    }
  };

  return (
    <>
      {printModal && (
        <PrintModal data={printModal} onClose={() => setPrintModal(false)} />
      )}
      {packageResultModal && (
        <PackageResultModal
          data={packageResultModal}
          onClose={() => {
            setPackageResultModal(false);
            mutate();
            setSelectedRowKeys([]);
          }}
        />
      )}
      {deleteResultModal && (
        <DeleteResultModal
          data={deleteResultModal}
          onClose={() => {
            setDeleteResultModal(false);
            mutate();
            setSelectedRowKeys([]);
          }}
        />
      )}
      <div style={{ float: "right" }}>
        <Space>
          <Button
            icon={<BiPackage />}
            disabled={selectedRowKeys.length < 1}
            onClick={() => {
              if (!info.authorities.includes("DELIVERY_PACKAGE")) {
                return message.error(
                  "Gönderi paketleme yetkiniz bulunmamaktadır!"
                );
              }
              Modal.confirm({
                title: "Toplu Gönderi Paketleme Onayı",
                content: `Tüm Seçilen gönderiler için paketleme onayı vermek istediğinizden emin misiniz?`,
                okText: "Evet",
                cancelText: "Hayır",
                onOk: () => {
                  const mergeData = selectedRowKeys.map((item) => {
                    const that = data.rows.find((x) => x._id === item);
                    return {
                      id: item,
                      barcode: that.barcode,
                      customerDeliveryNo: that.customerDeliveryNo,
                      totalParcels: that.totalParcels,
                    };
                  });
                  setPackageResultModal(mergeData);
                },
              });
            }}
          >
            Toplu Paketle
          </Button>
          <Button
            icon={<AiFillDelete />}
            disabled={selectedRowKeys.length < 1}
            type="danger"
            onClick={() => {
              if (!info.authorities.includes("DELIVERY_PACKAGE")) {
                return message.error("Gönderi silme yetkiniz bulunmamaktadır!");
              }
              Modal.confirm({
                title: "Toplu Gönderi Silme Onayı",
                content: `Tüm Seçilen gönderiler için silme onayı vermek istediğinizden emin misiniz?`,
                okText: "Evet",
                cancelText: "Hayır",
                onOk: () => {
                  const mergeData = selectedRowKeys.map((item) => {
                    const that = data.rows.find((x) => x._id === item);
                    return {
                      id: item,
                      barcode: that.barcode,
                      customerDeliveryNo: that.customerDeliveryNo,
                    };
                  });
                  setDeleteResultModal(mergeData);
                },
              });
            }}
          >
            Toplu Sil
          </Button>
        </Space>
      </div>

      <DataTable
        name="Gönderi Listesi"
        {...logics}
        dataSource={data?.rows || []}
        rowKey="id"
        loading={loading}
        mutate={() => mutate()}
        pagination={{
          pageSizeOptions: [25, 50, 100, 250],
          total: data.totalRowCounts,
          pageSize: pagination.limit,
          current: pagination.page,
          onChange: (page, limit) => {
            setPageAndLimit({ page, limit });
          },
          showSizeChanger: true,
        }}
        rowSelection={{
          selectedRowKeys,
          onChange: (val) => setSelectedRowKeys(val),
        }}
      />
    </>
  );
};

export default Table;
